import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LotteryInstallmentConfigurationModel } from "src/app/model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "src/app/model/SchemeInstallmentConfigurationModel";
import { InstallmentConfigService } from "src/app/services/installment-config.service";
import { InstallmentConfigModalComponent } from "./installment-config-modal/installment-config-modal.component";
import { ModalController } from "@ionic/angular";
import { InstallmentConfigEditModalComponent } from "./installment-config-edit-model/installment-config-edit-model.component";

@Component({
  selector: "app-secure-installment-config",
  templateUrl: "./installment-config.component.html",
  styleUrls: ["./installment-config.component.scss"],
})
export class InstallmentConfigComponent implements OnInit {
  isLoading = false;
  lotteries: { [key: number]: string };
  schemes: { [key: number]: string };
  installmentTypes: { [key: number]: string };
  lotteryInstallmentConfigs: LotteryInstallmentConfigurationModel[] = [];
  schemeInstallmentConfigs: SchemeInstallmentConfigurationModel[] = [];
  isSubmitDisabled: boolean = false;
  lotteryKey: { key: number; value: string };
  schemeKey: { key: number; value: string };
  isAddAllowedForLottery: boolean;
  isAddAllowedForScheme: boolean;
  otherInstallmentNames: string[];

  constructor(
    private router: Router,
    private modalCtrl: ModalController,
    private installmentConfigService: InstallmentConfigService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.installmentConfigService.initInstallmentConfigurationForm().subscribe(
      (data) => {
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.lotteries = data.lotteries;
          this.otherInstallmentNames = data.otherInstallmentNames;
        } else {
          this.installmentConfigService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.installmentConfigService.errorToast(
          error?.error?.message || error?.error?.errorMessage
        );
        this.isLoading = false;
      }
    );
  }

  onLotteryChange(e: any) {
    this.schemes = {};
    this.installmentTypes = {};
    this.lotteryInstallmentConfigs = [];
    this.schemeInstallmentConfigs = [];
    this.isAddAllowedForLottery = false;
    this.isAddAllowedForScheme = false;
    if (e?.key > 0) {
      this.isLoading = true;
      this.installmentConfigService.initWithLottery(e.key).subscribe(
        (data) => {
          this.isLoading = false;
          if (data.status === "SUCCESS") {
            this.schemes = data.schemes;
            this.installmentTypes = data.installmentTypes;
            this.lotteryInstallmentConfigs =
              data.lotteryInstallmentConfigs.sort((a, b) => a.key - b.key);

            this.isAddAllowedForLottery = !(
              this.lotteryInstallmentConfigs &&
              this.lotteryInstallmentConfigs.length > 0
            );
          } else {
            this.installmentConfigService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.installmentConfigService.errorToast(
            error?.error?.message || error?.error?.errorMessage
          );
          this.isLoading = false;
        }
      );
    }
    // this.installmentConfigService
    //   .initWithLotteryEdit("FIRST_INSTALLMENT", e.key)
    //   .subscribe(
    //     (data) => {
    //       this.isLoading = false;
    //       if (data.status === "SUCCESS") {
    //         this.schemes = data.schemes;
    //         this.installmentTypes = data.installmentTypes;
    //         this.lotteryInstallmentConfigs =
    //           data.lotteryInstallmentConfigs.sort((a, b) => a.key - b.key);

    //         this.isAddAllowedForLottery = !(
    //           this.lotteryInstallmentConfigs &&
    //           this.lotteryInstallmentConfigs.length > 0
    //         );
    //       } else {
    //         this.installmentConfigService.errorToast(data.errorMessage);
    //       }
    //     },
    //     (error) => {
    //       this.installmentConfigService.errorToast(
    //         error?.error?.message || error?.error?.errorMessage
    //       );
    //       this.isLoading = false;
    //     }
    //   );
  }

  onSchemeChange(e: any) {
    this.schemeInstallmentConfigs = [];
    this.isAddAllowedForScheme = false;
    if (e?.key > 0) {
      this.isLoading = true;
      this.installmentConfigService
        .initWithScheme(this.lotteryKey?.key, e.key)
        .subscribe(
          (data) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.schemeInstallmentConfigs =
                data.schemeInstallmentConfigs.sort((a, b) => a.key - b.key);

              this.isAddAllowedForScheme = !(
                this.schemeInstallmentConfigs &&
                this.schemeInstallmentConfigs.length > 0
              );
            } else {
              this.installmentConfigService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.installmentConfigService.errorToast(
              error?.error?.message || error?.error?.errorMessage
            );
            this.isLoading = false;
          }
        );
    }
  }

  async onLotteryInstallmentConfigurationAdd() {
    let totalPercent =
      this.lotteryInstallmentConfigs &&
      this.lotteryInstallmentConfigs.length > 0 &&
      this.lotteryInstallmentConfigs.filter((s) => s.otherCharge === "N")
        .length > 0
        ? this.lotteryInstallmentConfigs
            .filter((s) => s.otherCharge === "N")
            .map((obj) => obj.installmentPercent)
            .reduce((o1, o2) => o1 + o2)
        : 0;
    console.log("totalPercent", totalPercent);
    let otherCharges =
      this.lotteryInstallmentConfigs &&
      this.lotteryInstallmentConfigs.length > 0 &&
      this.lotteryInstallmentConfigs.filter((l) => l.otherCharge === "Y")
        .length > 0
        ? Math.max.apply(
            Math,
            this.lotteryInstallmentConfigs
              .filter((s) => s.otherCharge === "Y")
              .map((obj) => obj.key)
          ) + 1
        : 11;

    let otherInstallmentNamesT = this.otherInstallmentNames.filter(
      (o) =>
        (this.lotteryInstallmentConfigs &&
        this.lotteryInstallmentConfigs.length > 0
          ? this.lotteryInstallmentConfigs
              .filter((l) => l.otherCharge === "Y")
              .map((l) => l.installmentType)
          : []
        ).indexOf(o) < 0
    );

    // if(totalPercent < 100) {
    let lotteryInstallmentConfigKeys = this.lotteryInstallmentConfigs?.map(
      (l) => l.key
    );
    let remainingInstallmentTypes = Object.keys(this.installmentTypes)
      ?.map((o) => {
        return { key: +o, value: this.installmentTypes[o] };
      })
      ?.filter((i) => lotteryInstallmentConfigKeys.indexOf(i.key) < 0)
      .sort((a, b) => {
        return a.key - b.key;
      });
    let installmentType = remainingInstallmentTypes[0];

    const modal = await this.modalCtrl.create({
      component: InstallmentConfigModalComponent,
      cssClass: "master-modal-lg",
      componentProps: {
        installmentConfigurationType: "Lottery",
        header: this.lotteries[this.lotteryKey.key],
        installmentType: totalPercent < 100 ? installmentType.value : null,
        installmentOrder: totalPercent < 100 ? installmentType.key : null,
        initialPercent: totalPercent < 100 ? 100 - totalPercent : 0,
        otherInstallmentType: !otherCharges ? "OTHER_CHARGES" : null,
        otherInstallmentOrder: otherCharges,
        otherInstallmentNames: otherInstallmentNamesT,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      console.log("data", data);
      this.lotteryInstallmentConfigs.push(
        new LotteryInstallmentConfigurationModel(
          data.key,
          data.lotteryInstKey,
          data.installmentType,
          data.installmentPercent,
          data.instPaymentInterestRate,
          data.installmentDuePaymentDays,
          data.installmentDuePaymentDaysWithInterest,
          data.otherCharge,
          data.installmentAmount,
          data.lotteryKey,
          data.intrestChartLst
        )
      );

      this.lotteryInstallmentConfigs = this.lotteryInstallmentConfigs.sort(
        (a, b) => a.key - b.key
      );
    }
    // }
    // else {
    //   this.installmentConfigService.errorToast("Total Installment Percent is already - "+totalPercent);
    // }
  }
  formatDate(dateString: string | null): string {
    if (dateString === null) {
      return "";
    }
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      // timeZoneName: "short",
    };

    const formattedDate = new Date(dateString).toLocaleDateString(
      "en-GB",
      options
    );

    return formattedDate;
  }
  deleteLotteryInstallmentConfig(key: number) {
    this.lotteryInstallmentConfigs = this.lotteryInstallmentConfigs.filter(
      (o) => o.key !== key
    );
  }
  deleteLotteryIntersetConfig(key: number) {
    this.lotteryInstallmentConfigs = this.lotteryInstallmentConfigs.filter(
      (o) => o.key !== key
    );
  }

  async onSchemeInstallmentConfigurationAdd() {
    let totalPercent =
      this.schemeInstallmentConfigs &&
      this.schemeInstallmentConfigs.length > 0 &&
      this.schemeInstallmentConfigs.filter((s) => s.otherCharge === "N")
        .length > 0
        ? this.schemeInstallmentConfigs
            .filter((s) => s.otherCharge === "N")
            .map((obj) => obj.installmentPercent)
            .reduce((o1, o2) => o1 + o2)
        : 0;

    let otherCharges =
      this.schemeInstallmentConfigs &&
      this.schemeInstallmentConfigs.length > 0 &&
      this.schemeInstallmentConfigs.filter((s) => s.otherCharge === "Y")
        .length > 0
        ? Math.max.apply(
            Math,
            this.schemeInstallmentConfigs
              .filter((s) => s.otherCharge === "Y")
              .map((obj) => obj.key)
          ) + 1
        : 11;

    let otherInstallmentNamesT = this.otherInstallmentNames.filter(
      (o) =>
        (this.schemeInstallmentConfigs &&
        this.schemeInstallmentConfigs.length > 0
          ? this.schemeInstallmentConfigs
              .filter((l) => l.otherCharge === "Y")
              .map((l) => l.installmentType)
          : []
        ).indexOf(o) < 0
    );

    // if(totalPercent < 100) {
    let schemeInstallmentConfigKeys = this.schemeInstallmentConfigs?.map(
      (l) => l.key
    );
    let remainingInstallmentTypes = Object.keys(this.installmentTypes)
      ?.map((o) => {
        return { key: +o, value: this.installmentTypes[o] };
      })
      ?.filter((i) => schemeInstallmentConfigKeys.indexOf(i.key) < 0)
      .sort((a, b) => {
        return a.key - b.key;
      });
    let installmentType = remainingInstallmentTypes[0];

    const modal = await this.modalCtrl.create({
      component: InstallmentConfigModalComponent,
      cssClass: "master-modal-lg",
      componentProps: {
        installmentConfigurationType: "Scheme",
        header: this.schemes[this.schemeKey?.key],
        installmentType: totalPercent < 100 ? installmentType.value : null,
        installmentOrder: totalPercent < 100 ? installmentType.key : null,
        initialPercent: totalPercent < 100 ? 100 - totalPercent : 0,
        otherInstallmentType: !otherCharges ? "OTHER_CHARGES" : null,
        otherInstallmentOrder: otherCharges,
        otherInstallmentNames: otherInstallmentNamesT,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      console.log("data", data);
      this.schemeInstallmentConfigs.push(
        new SchemeInstallmentConfigurationModel(
          data.key,
          data.schemeInstKey,
          data.installmentType,
          data.installmentPercent,
          data.instPaymentInterestRate,
          data.installmentDuePaymentDays,
          data.installmentDuePaymentDaysWithInterest,
          data.otherCharge,
          data.installmentAmount,
          data.lotteryKey,
          data.schemeKey,
          data.intrestChartLst
        )
      );

      this.schemeInstallmentConfigs = this.schemeInstallmentConfigs.sort(
        (a, b) => a.key - b.key
      );
      console.log("dfg", this.schemeInstallmentConfigs);
    }
  }
  async onLotteryInstallmentConfigurationEdit(
    item: LotteryInstallmentConfigurationModel
  ) {
    console.log("item", item);
    const modal = await this.modalCtrl.create({
      component: InstallmentConfigEditModalComponent,
      cssClass: "master-modal-lg",
      componentProps: {
        installmentConfigurationType: "Lottery",
        header: this.lotteries[this.lotteryKey.key],
        installmentType: item.installmentType,
        installmentOrder: item.key,
        initialPercent: item.installmentPercent,
        initialPayDays: item.installmentDuePaymentDays,
        initialWithIntPayDays: item.installmentDuePaymentDaysWithInterest,
        otherInstallmentType: item.otherCharge === "Y" ? "OTHER_CHARGES" : null,
        otherInstallmentOrder: item.otherCharge === "Y" ? item.key : null,
        otherInstallmentNames: this.otherInstallmentNames,
        lotteryKey: this.lotteryKey.key,
        lotteryInstKey: item.lotteryInstKey,
        // isEdit: true, // Flag to indicate edit mode
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      console.log("LotteryInstallmentConfigurationModeldata", data);

      const indexToUpdate = this.lotteryInstallmentConfigs.findIndex(
        (config) => config.installmentType === data.installmentType
      );

      if (indexToUpdate !== -1) {
        // Object with matching lotteryInstKey found, update it
        this.lotteryInstallmentConfigs[indexToUpdate] =
          new LotteryInstallmentConfigurationModel(
            data.key,
            data.lotteryInstKey,
            data.installmentType,
            data.installmentPercent,
            data.instPaymentInterestRate,
            data.installmentDuePaymentDays,
            data.installmentDuePaymentDaysWithInterest,
            data.otherCharge,
            data.installmentAmount,
            data.lotteryKey,
            data.intrestChartLst
          );
      } else {
        // Object with matching lotteryInstKey not found, push a new one
        this.lotteryInstallmentConfigs.push(
          new LotteryInstallmentConfigurationModel(
            data.key,
            data.lotteryInstKey,
            data.installmentType,
            data.installmentPercent,
            data.instPaymentInterestRate,
            data.installmentDuePaymentDays,
            data.installmentDuePaymentDaysWithInterest,
            data.otherCharge,
            data.installmentAmount,
            data.lotteryKey,
            data.intrestChartLst
          )
        );
      }

      this.lotteryInstallmentConfigs = this.lotteryInstallmentConfigs.sort(
        (a, b) => a.key - b.key
      );
    }
  }
  async onSchemeInstallmentConfigurationEdit(
    item: SchemeInstallmentConfigurationModel
  ) {
    console.log("item", item);
    console.log(" item.installmentType", item);
    const modal = await this.modalCtrl.create({
      component: InstallmentConfigEditModalComponent,
      cssClass: "master-modal-lg",
      componentProps: {
        installmentConfigurationType: "Scheme",
        header: this.schemes[this.schemeKey.key],
        installmentType: item.installmentType,
        installmentOrder: item.key,
        initialPercent: item.installmentPercent,
        initialPayDays: item.installmentDuePaymentDays,
        initialWithIntPayDays: item.installmentDuePaymentDaysWithInterest,
        otherInstallmentType: item.otherCharge === "Y" ? "OTHER_CHARGES" : null,
        otherInstallmentOrder: item.otherCharge === "Y" ? item.key : null,
        initialAmount: item.installmentAmount,
        otherInstallmentNames: this.otherInstallmentNames,
        lotteryKey: this.lotteryKey.key,
        schemeKey: this.schemeKey.key,
        schemeInstKey: item.schemeInstKey,
        // isEdit: true, // Flag to indicate edit mode
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "submit") {
      console.log("SchemeInstallmentConfigurationModeldata", data);
      console.log("item.lotteryInstKey", item.schemeInstKey);
      const indexToUpdate = this.schemeInstallmentConfigs.findIndex(
        (config) => config.installmentType === data.installmentType
      );

      if (indexToUpdate !== -1) {
        // Object with matching schemeInstKey found, update it
        this.schemeInstallmentConfigs[indexToUpdate] =
          new SchemeInstallmentConfigurationModel(
            data.key,
            data.schemeInstKey,
            data.installmentType,
            data.installmentPercent,
            data.instPaymentInterestRate,
            data.installmentDuePaymentDays,
            data.installmentDuePaymentDaysWithInterest,
            data.otherCharge,
            data.installmentAmount,
            data.lotteryKey,
            data.schemeKey,
            data.intrestChartLst
          );
      } else {
        // Object with matching schemeInstKey not found, push a new one
        this.schemeInstallmentConfigs.push(
          new SchemeInstallmentConfigurationModel(
            data.key,
            data.schemeInstKey,
            data.installmentType,
            data.installmentPercent,
            data.instPaymentInterestRate,
            data.installmentDuePaymentDays,
            data.installmentDuePaymentDaysWithInterest,
            data.otherCharge,
            data.installmentAmount,
            data.lotteryKey,
            data.schemeKey,
            data.intrestChartLst
          )
        );
      }

      this.schemeInstallmentConfigs = this.schemeInstallmentConfigs.sort(
        (a, b) => a.key - b.key
      );
    }
  }

  deleteSchemeInstallmentConfig(key: number) {
    this.schemeInstallmentConfigs = this.schemeInstallmentConfigs.filter(
      (o) => o.key !== key
    );
  }
  deleteSchemeIntersetConfig(key: number) {
    this.schemeInstallmentConfigs = this.schemeInstallmentConfigs.filter(
      (o) => o.key !== key
    );
  }

  onLotteryInstallmentConfigurationSubmit() {
    if (
      this.lotteryInstallmentConfigs &&
      this.lotteryInstallmentConfigs.length > 0
    ) {
      let firstInstallment = this.lotteryInstallmentConfigs.filter(
        (obj) => obj.installmentType === "FIRS_INSTALLMENT"
      );

      if (!firstInstallment) {
        this.installmentConfigService.errorToast(
          "Installment Configuration should have First Installment"
        );
      }

      let totalPercent =
        this.lotteryInstallmentConfigs &&
        this.lotteryInstallmentConfigs.length > 0
          ? this.lotteryInstallmentConfigs
              .filter((o) => o.otherCharge === "N")
              .map((obj) => obj.installmentPercent)
              .reduce((o1, o2) => o1 + o2)
          : 0;

      if (totalPercent > 0) {
        this.installmentConfigService
          .saveLotteryInstallmentConfiguration(
            this.lotteryKey?.key,
            this.lotteryInstallmentConfigs
          )

          .subscribe(
            (data: any) => {
              this.isSubmitDisabled = false;
              if (data.status === "SUCCESS") {
                this.installmentConfigService.successToast(
                  "Saved Successfully"
                );
                this.onLotteryChange(this.lotteryKey);
              } else {
                this.installmentConfigService.errorToast(
                  data.errorMessage,
                  5 * 1000
                );
              }
            },
            (error) => {
              this.isSubmitDisabled = false;
              console.log(error);
              this.installmentConfigService.errorToast(
                error?.error?.message || error?.error?.errorMessage,
                5 * 1000
              );
            }
          );
      } else {
        this.installmentConfigService.errorToast(
          "Total Installment Percent should be greater than 0"
        );
      }
    } else {
      this.installmentConfigService.errorToast(
        "Please enter Installment Configuration for Lottery"
      );
    }
  }

  onSchemeInstallmentConfigurationSubmit() {
    console.log(
      " this.schemeInstallmentConfigs",
      this.schemeInstallmentConfigs
    );
    if (
      this.schemeInstallmentConfigs &&
      this.schemeInstallmentConfigs.length > 0
    ) {
      let firstInstallment = this.schemeInstallmentConfigs.filter(
        (obj) => obj.installmentType === "FIRS_INSTALLMENT"
      );

      if (!firstInstallment) {
        this.installmentConfigService.errorToast(
          "Installment Configuration should have First Installment"
        );
      }

      let totalPercent =
        this.schemeInstallmentConfigs &&
        this.schemeInstallmentConfigs.length > 0
          ? this.schemeInstallmentConfigs
              .filter((o) => o.otherCharge === "N")
              .map((obj) => obj.installmentPercent)
              .reduce((o1, o2) => o1 + o2)
          : 0;

      if (totalPercent > 0) {
        console.log(
          " this.schemeInstallmentConfigs",
          this.schemeInstallmentConfigs
        );
        this.installmentConfigService
          .saveSchemeInstallmentConfiguration(
            this.lotteryKey?.key,
            this.schemeKey?.key,
            this.schemeInstallmentConfigs
          )
          .subscribe(
            (data: any) => {
              this.isSubmitDisabled = false;
              if (data.status === "SUCCESS") {
                this.installmentConfigService.successToast(
                  "Saved Successfully"
                );
                this.onSchemeChange(this.schemeKey);
              } else {
                this.installmentConfigService.errorToast(
                  data.errorMessage,
                  5 * 1000
                );
              }
            },
            (error) => {
              this.isSubmitDisabled = false;
              console.log(error);
              this.installmentConfigService.errorToast(
                error?.error?.message || error?.error?.errorMessage,
                5 * 1000
              );
            }
          );
      } else {
        this.installmentConfigService.errorToast(
          "Total Installment Percent should be greater than 0"
        );
      }
    } else {
      this.installmentConfigService.errorToast(
        "Please enter Installment Configuration for Scheme"
      );
    }
  }
  edit(key: number) {
    this.router.navigate(["/secure", "installment-config"]);
  }
}
